// client/src/components/leagues/MatchCentralHeader.js
import React from 'react'
import PropTypes from 'prop-types'

/**
 * MatchCentralHeader - Displays the header section for Match Central
 * including league/division name, finalized badge, and location information
 */
export default function MatchCentralHeader({
  matchData,
  leagueId,
  isFinalized,
}) {
  return (
    <div className="match-central-header mb-4">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div className="flex-grow-1">
          <h4 className="mb-1">
            <span className="text-success me-2">🎾</span>
            Match Central
          </h4>
          {matchData && (
            <p className="text-muted mb-0 small">
              {matchData.league_name || `League #${leagueId}`}
              {matchData.division_name && ` – ${matchData.division_name}`}
            </p>
          )}
          {!matchData && (
            <p className="text-muted mb-0 small">
              League #{leagueId} – Match loading...
            </p>
          )}
        </div>
        {isFinalized && <span className="badge bg-success">Finalized</span>}
      </div>

      {/* Match court information */}
      {matchData && matchData.home_court_name && (
        <div className="d-flex align-items-center">
          <span className="text-success me-3" style={{ fontSize: '1.5em' }}>
            📍
          </span>
          <div>
            <div className="fw-semibold">{matchData.home_court_name}</div>
            {(matchData.home_court_city || matchData.home_court_state) && (
              <small className="text-muted">
                {[matchData.home_court_city, matchData.home_court_state]
                  .filter(Boolean)
                  .join(', ')}
              </small>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

MatchCentralHeader.propTypes = {
  matchData: PropTypes.shape({
    league_name: PropTypes.string,
    division_name: PropTypes.string,
    home_court_name: PropTypes.string,
    home_court_city: PropTypes.string,
    home_court_state: PropTypes.string,
  }),
  leagueId: PropTypes.string.isRequired,
  isFinalized: PropTypes.bool.isRequired,
}
